import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import AnimateEntrance from '../helper/animate';

class QuestPageController {
	constructor(vc, conf) {
		this.config = conf;
		this.vc = vc;
		this.timeout = null;
		if (vc) {
			this.vc = vc[this.config.holder];
		} else {
			throw new Error(
				'QuestPageController failed init ' + JSON.stringify(this.config)
			);
		}
		AnimateEntrance(this.vc.parent);
		this.addEventListeners();
	}

	addEventListeners() {
		window.addEventListener(EVENTS.MODAL, this, false);
		window.addEventListener(EVENTS.REEL_FINISHED, this, false);
		if (
			GameConfigs.settings.keyboard_shortcuts &&
			!window.isMobile &&
			!window.isTablet
		) {
			window.addEventListener('keydown', this, false);
		}
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		window.sm.play({ name: 'bonus_buy_quest_open_sfx' });
		this.timeout = setTimeout(() => {
			//add event after a small delay when the component is rendered
			window.addEventListener(EVENTS.INTERACTION, this, false);
		}, 100);
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.INTERACTION:
				const target = this.vc.getBounds();
				if (
					GameConfigs.modal === 'quest' ||
					GameConfigs.modal === 'quest_claim'
				) {
					if (
						HELPERS.handleOutsideClick(
							target,
							evt.x,
							evt.y,
							this.config.name,
							true
						)
					) {
						window.removeEventListener(EVENTS.INTERACTION, this, false);
						this.removeEvents();
					}
				}
				break;
			case EVENTS.MODAL:
				this.removeEvents();
				break;
			case 'keydown':
				if (
					evt.keyCode === 27 ||
					(evt.keyCode === 32 && !GameConfigs.disabled.spin)
				) {
					if (
						GameConfigs.modal === 'quest' ||
						GameConfigs.modal === 'quest_claim'
					) {
						HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
					}
					this.removeEvents();
				}
				break;

			case EVENTS.REEL_FINISHED:
				if (GameConfigs.win > 0) {
					HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
					this.removeEvents();
				}
				break;
			default:
				break;
		}
	}
	removeEvents() {
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		window.sm.play({ name: 'bonus_buy_quest_close_sfx' });
		window.removeEventListener(EVENTS.INTERACTION, this, false);
		window.removeEventListener(EVENTS.MODAL, this, false);
		window.removeEventListener(EVENTS.REEL_FINISHED, this, false);
		window.removeEventListener('keydown', this, false);
	}
}

export default QuestPageController;
